import React, { useEffect, useState } from 'react';
import ServiceCard from '../ServiceCard/ServiceCard';
import './ServicesStyle.css'


const ServicesMain = () => {
    const [services, setServices] = useState([])
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/services')
        .then(res => res.json())
        .then(data => setServices(data))
    }, [])
    console.log(services)
    return (
        <div className="p-5">
            <div>
            <p className="text-center mt-5 text-color">service</p>
            <h1 className="text-center mb-5 text-color"><b>We're an company tailored to all <br/> clients' needs always delivers</b></h1>
            <div className="row d-flex justify-content-center mb-5">
                {
                    services.map(service => <ServiceCard service={service}/>)
                }
            </div>
            </div>
        </div>
    );
};

export default ServicesMain;